var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1997 13.4H14.2517L13.9157 13.076C15.0917 11.708 15.7997 9.93198 15.7997 7.99998C15.7997 3.69198 12.3077 0.199982 7.99971 0.199982C3.69171 0.199982 0.199707 3.69198 0.199707 7.99998C0.199707 12.308 3.69171 15.8 7.99971 15.8C9.93171 15.8 11.7077 15.092 13.0757 13.916L13.3997 14.252V15.2L19.3997 21.188L21.1877 19.4L15.1997 13.4ZM8.0001 13.4C5.0121 13.4 2.6001 10.988 2.6001 8.00001C2.6001 5.01201 5.0121 2.60001 8.0001 2.60001C10.9881 2.60001 13.4001 5.01201 13.4001 8.00001C13.4001 10.988 10.9881 13.4 8.0001 13.4ZM11.0001 7.40001H5.0001V8.60001H11.0001V7.40001Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutIcon);
export default __webpack_public_path__ + "static/media/zoom-out-icon.bdaf47c89a7697d8732359966311f08b.svg";
export { ForwardRef as ReactComponent };